<div class="not-found-container">
  <div class="content">
    <h1>404</h1>
    <h3>Oops! Page not found.</h3>
    <p>The page you are looking for might have been removed or is temporarily unavailable.</p>
    <button routerLink="/">Back to Home</button>
  </div>
</div>
